module.exports = __webpack_public_path__ + "img/portfolio6.d1221936.jpg";